/*
 *  Copyright © 2025 Cenozon Inc. All Rights Reserved.
 */
import { sideBarReducerConstant } from '../../reducerConstant';

const initialState = {
   showSideBar: false,
   minimized: false
};

const sideBarReducer = (state = initialState, action = {}) => {
   switch (action.type) {
      case sideBarReducerConstant.UPDATE_SIDE_BAR_STATE:
         return {
            ...state,
            showSideBar: action.value
         };
      case sideBarReducerConstant.TOGGLE_SIDEBAR_MINIMIZED:
         return {
            ...state,
            minimized: action.minimized
         };
      default:
         return state;
   }
};

export default sideBarReducer;
